
import { Component, Vue } from 'vue-property-decorator';
import { AccountInfo } from '@airgap/beacon-sdk';
import Table from '@/components/Table.vue';
import { TradeFromTzstats } from '@/lib/types-helper';
import { Module1Module } from '@/store/modules/module1';

@Component({
  components: {
    Table
  }
})
export default class Trades extends Vue {
  showModal = false;
  allowModalToBeClosed = false;
  modalTitle = 'Please Wait';
  modalParagraph = 'Transaction pending...'

  get account () : AccountInfo | undefined | null {
    return Module1Module.account;
  }

  get myOpenContractTradeData () : TradeFromTzstats[] {
    let data = Module1Module.myContractTradeData;
    data = data.filter((datum) => {
      return !datum.value.executed;
    });
    return data;
  }

  get myPastContractTradeData () : TradeFromTzstats[] {
    let data = Module1Module.allContractTradeData;
    data = data.filter((datum) => {
      console.log(datum.value.proposal);
      return datum.value.executed &&
        Module1Module.account &&
        (
          datum.value.proposal.proposer === Module1Module.account.address ||
          datum.value.executor === Module1Module.account.address
        );
    });
    return data;
  }

  async mounted () : Promise<void> {
    await Module1Module.FetchAllContractTradeData();
  }
}
